import styled from 'styled-components'

export const SettingsContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`

export const KeywordSection = styled.div`
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
`

export const KeywordSectionTitle = styled.h3`
  margin-bottom: 15px;
  color: #333;
  font-size: 1.2rem;
  font-weight: 600;
`

export const KeywordList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 15px;
`

export const KeywordTag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 20px;
  font-size: 0.9rem;
  color: #1976d2;
`

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  
  &:hover {
    background-color: #ffebee;
  }
  
  &:disabled {
    color: #ccc;
    cursor: not-allowed;
    
    &:hover {
      background-color: transparent;
    }
  }
`

export const AddKeywordForm = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

export const KeywordInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  
  &:focus {
    outline: none;
    border-color: #2196f3;
    box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
  }
  
  &:disabled {
    background-color: #f5f5f5;
    color: #999;
    cursor: not-allowed;
  }
`

export const AddButton = styled.button`
  padding: 8px 16px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  
  &:hover {
    background-color: #45a049;
  }
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    
    &:hover {
      background-color: #ccc;
    }
  }
`

export const SaveButton = styled.button`
  padding: 12px 24px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  
  &:hover {
    background-color: #1976d2;
  }
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    
    &:hover {
      background-color: #ccc;
    }
  }
`

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
` 